<!-- =========================================================================================
	File Name: notificationAlert.vue
	Description: notificationAlert component
	Component Name: notificationAlert
========================================================================================== -->


<template>
  <vs-prompt
    :vs-title="'风控提醒 - ' + content.title"
    :vs-accept-text="content.isRead == 1 ? '确认' : '已读'"
    vs-cancel-text="取消"
    :vs-color="content.isRead == 1 ? 'primary' : 'success'"
    @vs-accept="read"
    :vs-active.sync="isShow"
    class="notification-alert"
  >
    <div class="mb-2">{{content.content}}</div>
    <div v-if="['sameIpLogin', 'sameIpRegister', 'sameIpRecharge', 'sameIpCash'].indexOf(content.type) > -1">
      <div>会员账号: <b>{{content.idList.replace(',', ', ')}}</b></div>
      <div>相同IP: <b>{{content.sameValue}}</b></div>
    </div>
    <div v-if="['sameBankName'].indexOf(content.type) > -1">
      <div>会员账号: <b>{{content.idList.replace(',', ', ')}}</b></div>
      <div>相同姓名: <b>{{content.sameValue}}</b></div>
    </div>
    <div v-if="['overCash'].indexOf(content.type) > -1">
      <div>会员账号: <b>{{content.idList}}</b></div>
      <div>提现金额: <b>{{content.sameValue}} 元</b></div>
    </div>
    <div v-if="['overBonus'].indexOf(content.type) > -1">
      <div>会员账号: <b>{{content.idList.split(',')[0]}}</b></div>
      <div>单笔盈利: <b>{{content.sameValue}} 元</b></div>
    </div>
  </vs-prompt>
</template>

<script>

export default {
    name: "notificationAlert",
    props: {
      content: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    data() {
      return {
        isShow: false
      }
    },
    methods: {
      show() {
        this.isShow = true
      },
      read() {
        this.$utils.post('notification-read', { authKey: localStorage.getItem('authKey'), id: this.content.id }).then(() => {
          this.$emit('read')
        })
      }
    }
}
</script>

<style>
  .notification-alert.con-vs-dialog .vs-dialog .vs-dialog-text {
    word-break: break-all;
  }
</style>
